import { Component } from '@angular/core';

@Component({
  selector: 'zc-step-caption',
  templateUrl: './step-caption.component.html',
})
export class StepCaptionComponent {}
